import { APPLICATION_ROUTES } from 'constants/routes';
import { lazy } from 'react';

// project imports
import MainLayout from 'shared/components/layout/MainLayout';
import Loadable from 'shared/components/ui-component/Loadable';
import { isNonProductionUi, isPoaUiEnabled } from 'shared/utils/featureFlags';
import OwnerGuard from 'shared/utils/route-guard/OwnerGuard';
import PoSoTrackingGuard from 'shared/utils/route-guard/PoSoTrackingGuard';

// sample page routing
const FranchisePartnersPage = Loadable(lazy(() => import('pages/franchise_partners')));
const FranchisePartnerDetailPage = Loadable(lazy(() => import('pages/franchise_partners/FranchisePartnerDetails')));
const FranchisePartnerCreatePage = Loadable(lazy(() => import('pages/franchise_partners/FranchisePartnerCreate')));
const CategoryManagementPage = Loadable(lazy(() => import('pages/category-management')));
const LocationGroupSettingsPage = Loadable(lazy(() => import('pages/LocationGroupSettings')));
const CoreProductsPage = Loadable(lazy(() => import('pages/CoreProducts')));
const DeliveryScheduleSettingsPage = Loadable(lazy(() => import('pages/delivery-schedule-settings')));
const AnnouncementsPage = Loadable(lazy(() => import('pages/announcements/index')));
const SupplierInvoiceExceptionsPage = Loadable(lazy(() => import('pages/supplier-invoice-exceptions/index')));
const PoSoTrackingPage = Loadable(lazy(() => import('pages/po-so-tracking/index')));
const IntegrationsPage = Loadable(lazy(() => import('pages/integrations/index')));
const GmailOAuthCallbackPage = Loadable(lazy(() => import('pages/integrations/GmailOAuthCallback')));
const XeroOAuthCallbackPage = Loadable(lazy(() => import('pages/integrations/XeroOAuthCallback')));
const FakeInvoicePage = Loadable(lazy(() => import('pages/debug/FakeInvoicePage')));

// ==============================|| OWNER ROUTING ||============================== //
const OwnerRoutes = {
    path: '/',
    element: (
        <OwnerGuard>
            <MainLayout />
        </OwnerGuard>
    ),
    children: [
        {
            path: APPLICATION_ROUTES.franchisePartners.list,
            element: <FranchisePartnersPage />
        },
        {
            path: APPLICATION_ROUTES.franchisePartners.detail,
            element: <FranchisePartnerDetailPage />
        },
        {
            path: APPLICATION_ROUTES.franchisePartners.create,
            element: <FranchisePartnerCreatePage />
        },
        {
            path: APPLICATION_ROUTES.categoryManagement,
            element: <CategoryManagementPage />
        },
        {
            path: APPLICATION_ROUTES.locationGroupSettings,
            element: <LocationGroupSettingsPage />
        },
        {
            path: APPLICATION_ROUTES.coreProducts,
            element: <CoreProductsPage />
        },
        {
            path: APPLICATION_ROUTES.deliveryScheduleSettings,
            element: <DeliveryScheduleSettingsPage />
        },
        {
            path: APPLICATION_ROUTES.announcements,
            element: <AnnouncementsPage />
        },
        {
            path: APPLICATION_ROUTES.supplierInvoiceExceptions,
            element: <SupplierInvoiceExceptionsPage />
        },
        ...(isPoaUiEnabled()
            ? [
                  {
                      path: APPLICATION_ROUTES.poSoTracking,
                      element: (
                          <PoSoTrackingGuard>
                              <PoSoTrackingPage />
                          </PoSoTrackingGuard>
                      )
                  },
                  {
                      path: APPLICATION_ROUTES.integrations,
                      element: (
                          <PoSoTrackingGuard>
                              <IntegrationsPage />
                          </PoSoTrackingGuard>
                      )
                  },
                  {
                      path: APPLICATION_ROUTES.gmailOAuthCallback,
                      element: (
                          <PoSoTrackingGuard>
                              <GmailOAuthCallbackPage />
                          </PoSoTrackingGuard>
                      )
                  },
                  {
                      path: APPLICATION_ROUTES.xeroOAuthCallback,
                      element: (
                          <PoSoTrackingGuard>
                              <XeroOAuthCallbackPage />
                          </PoSoTrackingGuard>
                      )
                  }
              ]
            : []),
        ...(isNonProductionUi()
            ? [
                  {
                      path: APPLICATION_ROUTES.debugFakeInvoice,
                      element: <FakeInvoicePage />
                  }
              ]
            : [])
    ]
};

export default OwnerRoutes;
